module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch2"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch2.jpg",
      "width": "64.86%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And yet on many a wintry night,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Young swains were gathered there.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For her father kept a social board,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And she was very fair.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-top": "5%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("I")]), _vm._v(" spent the next few days curled up in a ball under the covers of my bed, trying not to move, or breathe, or think, or fall asleep and dream about what had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("They think that perhaps the brakes on his bike failed …")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I knew that Jay’s old bike had been falling apart. That was why he’d been saving up for a new one. I tried to remember whether he’d said anything specifically about the brakes not working, but everything was a jumbled-up mess inside my head and I couldn’t think straight. I just kept coming back to Jay standing there with his bike in the parking lot …")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("All right, Sophie. I’ll take the towpath …")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t sleep that first night. I couldn’t stop thinking about the Ouija board, or the girl I thought I’d seen in the café, or the cold fingers that had curled into my hand when it all went dark. Or Jay, lying on some undertaker’s slab somewhere, all by himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next day, in a kind of daze, I started reading about Ouija boards online, going through pages and pages of sites, squinting at the screen with raw and bloodshot eyes, and the more I read, the worse I felt. When I looked up the app itself, it was only to find that it had been taken down. There was a one-sentence explanation from the manufacturers stating that the app had been withdrawn due to complaints received from customers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There were so many warnings about Ouija boards—people had been hurt using them, and others had died. One girl had posted a message on a forum saying: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Never, ever, ever use one of these things. They’re not safe, and they’re definitely not fun, and I just want to warn everyone so that no one else loses their best friend like I did.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I shivered, wishing I had read her warning before Jay had downloaded that stupid app.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One of the sites said that if the planchette did a figure eight, it meant that an evil spirit was in control of the board. I thought back and tried to remember whether it had done that or not; it was hard to remember properly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But there were two things I found out that disturbed me more than the rest. The first was the discovery that there were three questions you must never ask a Ouija board:")]), _vm._v(" "), _c('ol', {
    staticClass: "ol-arabic"
  }, [_c('li', {
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_vm._v("Never ask about God.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_vm._v("Never ask where the gold is buried.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_vm._v("Never ask when you’re going to die.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And the second discovery—the one that made me feel worst of all—was a warning printed in bold text that said you must never, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ever")]), _vm._v(" allow a planchette to count down through the numbers because a spirit could get out of the board that way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But our planchette "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" counted down through the numbers. When it had gotten to zero, that was when the waitress in the kitchen had started screaming …")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tried to tell myself it was just a coincidence, that what had happened to Jay had nothing to do with Ouija boards or spirits or anything like that, but it didn’t help because even if Jay’s death "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" been an accident caused by his failing brakes, it was still my fault. I’d asked him to take the towpath. I had asked him to do that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anything for you …")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The week passed in a blur of misery. I didn’t know what to do with myself. Whenever I’d been unhappy before, it had always been Jay who would cheer me up. I kept expecting him to text me again, or walk through the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And whenever I was upstairs by myself I couldn’t shake the sensation that there was someone there in the room with me, someone I couldn’t see.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was like there were hidden eyes staring and staring at me until my skin itched and my neck burned. I tried going downstairs, hoping that the feeling might go away if Mom was nearby, but it didn’t make any difference.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One day I was sitting in front of the TV, still wearing my pajamas because getting dressed seemed like too much effort, when I could’ve sworn I felt icy-cold fingers brush against my face. I leaped to my feet, spilling the bowl of popcorn Mom had just brought me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rebecca?” I said, staring around the room. “Are you there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the room was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mom came in a moment later to see what all the fuss was about. “What’s going on in here?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mom.” I swallowed hard and tried to sound normal. “Did you ever mess around with a Ouija board when you were younger?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What a strange question,” Mom replied, bending down to gather up the popcorn. “Not that I can remember. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s just that … Jay and I were playing with one the night that … the night that he died.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But where did you find one?” Mom asked, looking up at me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wasn’t an actual board—it was an app Jay had downloaded on his phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, one of those phone game things?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wasn’t a game, Mom, it … It said that Jay was going to die that night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mom stood up and came towards me. “Oh, Sophie, you’re not going to let that upset you, are you? An app can’t tell you when you’re going to die.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But it wasn’t just an app, Mom, it was a Ouija board. I’ve read that they’re supposed to be dangerous, that sometimes an evil spirit can—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Darling, what happened to Jay has got nothing to do with anything either one of you did that night.” She hesitated a moment, then said, “Listen, why don’t I call the school and see if you could go and talk with the counselor there? It might make you feel better to speak to a professional about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was shaking my head before she’d even finished the sentence. “That’s the last thing I want to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right,” Mom said, holding up her hands and backing off. “It was just a suggestion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I knew that nothing I said was going to convince her, and yet my cheek still felt cold, as if icy fingers really had stroked my skin. I’d felt weirdly different ever since that night, but the feeling wasn’t something I could explain, to Mom or to anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tried to tell myself it was just grief and guilt making me think strange things. After all, even if we had made contact with Rebecca, and even if she had escaped from the board, why would she have hurt Jay? He’d never done anything to her; he’d never even met her. But when I started to read about ghosts online I kept coming across the theory that if someone died under suspicious circumstances then they would become a vengeful spirit who wouldn’t care who they hurt, and would just go on hurting people until they got justice. And I still didn’t know how Rebecca had died.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tried asking Mom later that day, but she just muttered something about an accident, and wouldn’t say any more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Promise me one thing, Jay had said. If anything happens to me, you’ll tell the world it was a ghost … you’ll tell the world …")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, he’d been joking, he hadn’t meant any of it, and yet … somehow, the crazy thought lodged itself in my brain that I owed it to Jay to at least find out whether a spirit had had anything to do with his death. And if Rebecca "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" been involved, well … I couldn’t let her get away with it. I had to do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("something")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So when Dad came and told me that he and Mom were going to cancel their anniversary trip and stay at home with me instead, I said I didn’t want them to, I still wanted to go and visit my uncle and cousins in Skye. Mom and Dad had been saving like mad for their trip to San Francisco and I knew they would lose the money if they canceled their flights. I told them everything they wanted to hear. “Being here will just remind me of what happened,” I said. “I’ll feel better somewhere else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That wasn’t true—all I wanted to do was cry in my room—but I must have been a better actress than I’d thought because, a week later, I was standing in the airport with my suitcase, waving good-bye to Mom and Dad.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("First there was the flight to Glasgow, then I had to catch a train to Mallaig and then, finally, get the ferry to Skye. It was an insane place to get to, which was why I’d only met my cousins, Cameron, Piper, and Rebecca, once, when they came to stay seven years ago. Cameron was some kind of musical prodigy, and they’d come down especially so that he could play the piano for an important music teacher in London. And I’d never even met my cousin Lilias—Aunt Laura had been pregnant with her when I’d last seen the family.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I felt a bit nervous about seeing Cameron, Piper, and Lilias. It was too late to turn back now, though.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had taken all day to get to Skye, and it was raining by the time I caught the ferry at Mallaig. It had been stiflingly hot the last couple of weeks so the rain was almost a relief, a fine summer drizzle that misted the air and clung to the ferry windows in big fat droplets, making it hard to see the island. I got my camera out of my bag, thinking that I might snap a photo as we approached, but really I think I just wanted to hold it and feel its familiar weight in my hands. It was my most prized possession.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The island emerged all of a sudden, huddled there in the water, starkly defined against the gray sky by jagged mountains that looked like they’d slice your hands open if you tried to climb them. What was I thinking, coming here like this? I could imagine what Jay would say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s this?” he’d gasp in an exaggerated tone of mock surprise. “Ghost hunting? You know you won’t last five minutes, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was probably true. I must have been insane to come here. What did I think I was going to be able to do? Track down Rebecca’s vengeful spirit and somehow banish it to the other side?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You ought to be flattered,” I said to Jay inside my head. “You die and I go crazy. What a compliment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t know whether it was thinking about Jay, or the choppiness of the sea, but I suddenly felt queasy, and I was glad when we pulled into the harbor at 6 p.m. It was pouring outside and the ferry speakers crackled to life as one of the staff made an announcement in a broad Scottish accent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ladies and gentlemen, as you can see, Skye is living up to its Gaelic name today, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the Island of Mist,")]), _vm._v(" so please mind your step on the gangplank, as it can get quite slippery out there. Welcome to the Sleat Peninsula, everyone, and enjoy your time on the island.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The gangplank led onto a sloped metal walkway that rose up out of the sea on stilts. The moment I stepped onto it, the wind whipped my hair around my face, and I could taste salt on my lips. By the time I reached the parking lot I was thoroughly soaked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I stared around, wondering where Uncle James would be. I couldn’t see him anywhere and, for a horrible moment, I was afraid he hadn’t come. Maybe he’d forgotten or gotten the times mixed up. I felt a twist of panic and dumped my suitcase on the wet tarmac so I could take my phone from my pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hand that clapped down on my shoulder from behind made me jump and I whirled around to see my uncle standing there with an umbrella. Tall and dark-haired, he looked nothing like Mom, but then they were stepsiblings rather than blood ones.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry,” he said. “I didn’t mean to startle you. I wasn’t sure it was you to begin with. You’ve grown up since I saw you last.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s … It’s been a long time,” I said, not sure what else to say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, it has,” Uncle James replied. “A long time. A very long time.” He was looking at me, but his expression was distant and I wondered if he was remembering the last time we’d met, when Rebecca had still been alive. Then he shook his head and seemed to see me again. “You’re soaked,” he said. “Let’s get you into the car.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I climbed into the front seat and shivered, wishing we were already at the house so that I could change into some dry clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hope you had a good journey, anyway?” Uncle James said as he got in. “It’s a long way to come on your own and this weather doesn’t help. We don’t have the best summers in Skye, I’m afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is it always this foggy?” I asked. The fog seemed to be coming in off the sea in waves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pretty much. The west coast is littered with shipwrecks because of captains who thought the fog was thin and that they’d be able to see the island in time. Entire crews have drowned as a result.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The mention of drowning made me think of Jay again, but not the way I wanted to think of him, not the living, breathing, laughing best friend I’d always known, but a body sprawled by the side of the canal, soaking wet and stone cold and gone forever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I felt suddenly tired. It was an hour and a half drive to the house and I leaned my head against the window, meaning to close my eyes for just a second, but I fell asleep right away and woke up some time later to Uncle James tapping my shoulder. The rain clouds and the fog made it seem very dark outside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re here, Sophie,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I rubbed the sleep from my eyes and looked up, expecting to see a house. But instead I saw gates looming before us in the harsh glare of the headlights. They were huge—two meters at least, set in a brick wall that was just as tall. A heavy-looking chain bound them together, and I watched as Uncle James got out and unlocked them before getting back into the car.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll give you the code for the combination lock, but you must never leave the gates open,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Daddy says never ever open the gate …")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sat up in my seat, suddenly wide awake. I was sure the Ouija-board app had said something just like that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why?” My voice came out as a dry croak.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I saw Uncle James’s mouth tighten. “It’s not safe,” he said. “In the morning you’ll see—the house is on a clifftop. It’s not safe in bad weather. Or after dark.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We drove through and he got out and locked the gate behind us. A long stone building huddled in the gleam of the headlights. I thought I saw a twitch of movement from one of the upstairs windows, as if a curtain had been pulled back and then quickly dropped. A strange little turret rose up from the center of the slate roof in the middle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s that?” I asked, pointing at it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The old bell tower,” Uncle James replied. “This used to be the schoolhouse. There’s no bell there anymore, though. It’s too windy here for that. It rang all the time and I couldn’t concentrate on my paintings. Well, your cousins will certainly be keen to see you—Piper has talked of nothing else for days.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now that I had finally arrived, I almost wished I was back on the ferry. I ran my fingers through my hair, hoping that it hadn’t dried in too much of a mess. Uncle James parked the car and we got out, our feet crunching on the gravel drive. The sea breeze was cool against my skin and I could hear the distant crashing of waves somewhere out in the fog.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s that burning smell?” I asked, suddenly becoming aware of it—a smell of smoke and hot ash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t smell anything,” Uncle James said and, weirdly, neither could I. The smell had disappeared all of a sudden, snatched away on the salty sea wind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Uncle James took my suitcase from the trunk and I followed him into the house. We walked into a deserted entrance hall with a tiled floor and a steep staircase leading up to the first floor. I didn’t like the look of that staircase. Something about it made my neck prickle. It was too tall and too steep. An accident waiting to happen. A staircase to break your neck on. And it was too warm inside the house, a stifling sort of airlessness that made sweat trickle down my back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s funny,” Uncle James said. “I thought they’d all be here to greet us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At that moment a door opened to the left and a girl came out. She was my own age so I knew this must be Piper. I remembered her being pretty, but the girl who rushed forward to greet me wasn’t just pretty, she was incredibly beautiful. She wore jeans and a simple pink sleeveless top with a high neckline. Her gorgeous strawberry blonde hair was pulled up into a thick ponytail and her eyes were a deep, sea-green color that made me think of mermaids.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I felt plain in comparison, and a little awkward, but Piper came right up and threw her arms around me as if we were long-lost sisters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, Sophie,” she said, hugging me tightly. “I’m so pleased that you’ve come to stay with us!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m glad too,” I said, wishing I didn’t sound so stiff and formal, and that my hair wasn’t such a total mess.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s Cameron?” Uncle James asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I saw Piper hesitate for a moment, as if she knew her dad wouldn’t like the answer. Then she said, “I … I’m not sure. He might have gone to his room. I’m sure he wanted to be here to greet Sophie but I think maybe he wasn’t feeling very well …”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t try to cover up for him, Piper!” Uncle James said sharply. “He seemed perfectly fine when I left and I made it quite clear that he was to be here to greet his cousin when we arrived.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I felt awkward about Cameron getting into trouble on my account and thought I ought to say something. “That’s all right—” I began.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s not all right,” Uncle James cut me off. “It’s extremely rude and I can only apologize on his behalf. I’m afraid you won’t find Cameron quite as you remember him. He hasn’t been the same since … well … Our family has had its share of troubles, as I’m sure you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I nodded and bit my tongue. I had to pick the right time to start asking questions about Rebecca and the second I arrived didn’t seem quite appropriate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And what about Lilias?” Uncle James asked. “Has she suddenly fallen ill too?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s up there, Dad,” Piper said. “On the staircase.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I realized with a start that Piper was right—there "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was ")]), _vm._v("a girl sitting on the stairs, but she had been so silent and unmoving that I hadn’t noticed her. Now I looked at the dark-haired girl staring down at us, unsmiling, from between the balustrades.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lilias, come down here and say hello to Sophie, please,” Uncle James said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lilias got to her feet, but rather than coming down, she turned around and, without a word, ran back up the stairs. A second later, we heard a door slam.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mustn’t mind Lilias,” Uncle James said. “She’s a nervous sort of child, but she’ll soon get used to you. Piper, why don’t you show Sophie around the house before dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course. Come on, I’ll give you the tour. We’ll start with your room and you can dump your bag.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I picked up my suitcase and followed her up the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“These all used to be bedrooms for the schoolmistress and the girls back when this was a school,” Piper said cheerfully. “This will be your room.” She threw open the door closest to the stairs and we walked into a bedroom with big bay windows and a vase of purple butterwort flowers on the bedside table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m so pleased you’re here,” Piper said. “I could really use the company. Lilias is too young and Cameron … well … he’s not much fun these days, I’m afraid. Let’s see if he’s skulking in his room.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I felt a bit nervous as I followed her down the hall, but when Piper opened the door to Cameron’s room, it was empty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I suppose he’s gone off somewhere.” Piper sighed. “You mustn’t pay any attention to him, Sophie, the only thing he cares about is his music.” I could tell as much from his bedroom, which was covered in loose piles of sheet music. “He really is very good, in spite of his … well, his injury. He’ll never be quite as accomplished as he was before, though, so you have to make allowances for him. I think that’s why he can be a bit … just a bit abrupt sometimes. He doesn’t mean it. That’s what I try to remember when he says cruel things to me, and you must do the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I thought back to meeting Cameron when we were kids and remembered him as a fun, good-natured boy who’d made a real effort to include me in games with his sisters. I found it hard to imagine him saying cruel things to anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He won’t be like you remember him,” Piper said, as if reading my mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What did you mean about him having an injury?” I asked. “I don’t remember that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, it was after we came to see you,” Piper replied. “He hurt his hand. In the fire. But don’t mention it to him, whatever you do—he’s terribly sensitive about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She showed me the other upstairs rooms—except for the one in between my room and Lilias’s.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s in there?” I asked, pointing at the closed door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We … We don’t use that room,” Piper said. “Not anymore.” She glanced at me and added under her breath, “It used to be my sister’s room, you see. Rebecca’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her cheerful tone had disappeared for the first time since I’d arrived, so I didn’t dare ask anymore questions. We went downstairs and Piper showed me the rest of the house, the heart of which was a huge, long room with a lofty vaulted ceiling, full-length windows and an actual stage at one end.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This used to be the school hall,” Piper said. “That’s why it’s so big. The pupils used to come here for assembly, and they performed their school plays on that stage there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was both a dining and sitting room, with a dining table at one end and a couch area at the other. I felt a bit unnerved by the tall windows running down its length. It still wasn’t dark outside but the rain clouds cloaked everything in shadow, and the effect of so many uncovered windows made it seem like the gloom was pressing in against the glass, trying to get into the house. I was used to curtains at home, and these bare windows made me feel like anyone could be staring in at us from outside and we would have no idea.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A massive black piano gleamed in the center of the stage. Piper scrambled up onto it and I followed her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is Cameron’s piano,” she said, running her hand over the smooth, polished surface. “It’s a baby grand. Dad bought it for him before his accident, back when we all thought he was going to be the next Mozart or something. It’s worth an absolute fortune—Dad had to remortgage the house to buy it. It’s Cameron’s pride and joy. Sometimes I think he cares about this piano more than he cares about any of us.” She laughed, but it came out kind of hollow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Next, we went into a room that smelled of chalk, with a big blackboard attached to one wall and three old-fashioned desks lined up in front of it. “This was one of the classrooms,” Piper said. “Those desks are from the original school. Cameron, Rebecca, and I used to do our homework here, and Lilias still does during exam time. Look, this photo is of the school in 1910.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pointed at the framed black-and-white photo hanging on the wall. It showed the house, looking exactly the same except that it didn’t have the high wall built around it, and you could clearly see the bell in the bell tower. A class of children were lined up outside the front door—there were about twenty of them, all girls, aged seven or eight. A teacher stood next to them, unsmiling, with her hands clasped primly in front of her. She looked plain and extremely serious. The children looked very serious too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think they had much fun in the olden days, do you?” Piper asked with a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was one girl in particular who caught my eye. She was in the front row, beside the teacher, and she was facing the photographer but she wouldn’t have been able to see him because she had a piece of cloth tied over her eyes. It reminded me of the blindfolds they covered someone’s eyes with when they were about to be executed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why is that girl wearing a blindfold?” I asked, pointing at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Piper shrugged. “I don’t know. She must have had something wrong with her eyes, I suppose. Maybe she was blind?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There were other photos on the wall, family photos. And one of them showed Cameron, Piper, and Rebecca. It must have been taken around the time they came to visit because they looked just as I remembered them. Cameron stood between his sisters, with an arm around each of them—he was smiling into the camera and so were the two girls. My eyes were drawn instantly to Rebecca. She had been incredibly pretty, with long black hair and violet eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was one of the last photos taken of Rebecca,” Piper said at my side. She sighed and said, “We look so happy, don’t we? I often look at this photo and wish I could go back to that moment. That I could warn them all about what was going to happen to us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she spoke she glanced at a photo of Aunt Laura that was hanging on the wall. Piper had clearly inherited her looks from her mom—they were very much alike, right down to the strawberry blonde hair. “Do you ever see her?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t know much about Aunt Laura, only that she’d had a nervous breakdown a couple of years ago and been committed to some kind of hospital.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Piper shook her head. “Dad visits her sometimes, but the doctors don’t think it will help her recovery to see us kids right now, so we don’t go. She just couldn’t cope after Rebecca died. Sometimes I wonder if that’s why Lilias is always so serious, you know? Mom cried every single day in the months before she was born. Cameron makes Lilias smile sometimes, but he’s the only one who can. And she never laughs.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Never?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not that I’ve seen. I don’t think she knows how, poor thing. Anyway, I’d better go and finish dinner. You’ve got time to go and freshen up if you want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I went back upstairs to my bedroom, where I changed into some fresh clothes and brushed my hair. When I opened the door to go back downstairs, Lilias was standing in the corridor. She was wearing jeans and a long-sleeved turtleneck, which surprised me—it was so muggy and warm inside the house, I’d swapped my top for a T-shirt. In her hands she held a soft toy ostrich.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello,” I said. Then I gestured to her ostrich and added, “What’s your friend’s name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I half thought she might run away again, but instead she held up her toy for me to see and said, “This is my ostrich. Her name is Hannah. She’s my best friend. She never says bad things to me. She never tells me to do horrible things.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Er … that’s good,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who’s your friend?” Lilias asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What friend?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The girl that came here with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I stared at her. “No one came with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, she did,” Lilias insisted. She pointed at Rebecca’s closed door and added, “She just went in there. She said it was her room but that’s not true. That’s my sister’s room.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I stared at her again. “No one came here with me, Lilias.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She was holding your hand when you walked through the front door.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I swallowed hard and, in my best, firm, grown-up voice, said, “That’s not true.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She scowled at me. “It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" true,” she said. “I don’t tell lies. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You’re")]), _vm._v(" the liar. I think you knew she was holding your hand all along. I think you brought her to our house on purpose. I wish you hadn’t come! I don’t like you and neither does Hannah!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And with that she ran straight past me, down the stairs and out of sight. So far I was doing a pretty pathetic job of trying to make friends with her. I stared after her for a second and then, slowly, turned my eyes to Rebecca’s closed door. I walked over and paused outside it. Then I reached out and brushed my fingertips lightly against its surface.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next second I gasped and snatched my hand back. The door was icy cold to the touch, but it wasn’t just the coldness that shocked me—it was the sudden sense of stone-cold evil I could feel radiating from the shut-up room. I couldn’t have put the feeling into words, not in a way that would make sense to anyone else, but it was dark and horrible and malevolent, and it made me feel slightly sick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I shivered and rubbed at the goosebumps on my arms. I felt a sudden urge to run—run as far away from this place as I could and never, ever look back. But, as I stood there staring at the door, I heard a thump, as if something heavy had just fallen to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And I could have sworn the sound came from inside Rebecca’s room.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1c5955","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545941099_ch002.vue
// module id = 72
// module chunks = 0